const closeTopMenuDropdownIfOnClick = () => {
    window.onclick = function (event) {
      var dropdown;
      if (!event.target.matches('#top-menu-dropdown-toggle')) {
        dropdown = document.getElementById("top-menu-dropdown");
        if (dropdown && dropdown.classList.contains('show')) {
          dropdown.classList.remove('show');
        }
      }
      if (!event.target.matches('.profile-box-dropdown-toggle')) {
        dropdown = document.getElementById("profile-dropdown");
        if (dropdown && dropdown.classList.contains('show')){
          dropdown.classList.remove('show');
        }
      }
    }
}

const getRequestConfig = () => {
  let request_config = {};
  let headers = {};
  headers["content-type"] = "application/json";
  request_config.headers = headers;
  request_config.data = {};
  return request_config;
}

export {
  closeTopMenuDropdownIfOnClick,
  getRequestConfig
}

